/** @format */
import {
  FETCH_INVENTORY_REQUEST,
  FETCH_INVENTORY_SUCCESS,
  FETCH_INVENTORY_FAILURE,
  CLEAR_INVENTORY,
} from "./InventoryTypes";

const initialState = {
  loading: false,
  inventoryData: [],
  status: 0,
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVENTORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_INVENTORY_SUCCESS:
      return {
        loading: false,
        inventoryData: action.payload,
        error: "",
        status: 1,
      };
    case FETCH_INVENTORY_FAILURE:
      return {
        loading: false,
        inventoryData: {},
        error: action.payload,
        status: 1,
      };
    case CLEAR_INVENTORY:
      return {
        loading: false,
        inventoryData: [],
        error: "",
        status: 0,
      };
    default:
      return state;
  }
};

export default reducer;
